import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  constructor(private http: HttpClient) {}

  postFile(file: any): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('isProfilePic', "yes");
    return this.http.post(`${SETTINGS.BASE_API}/files/upload-profile`, formData);
  }

  postSingleFile(file: any): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post(`${SETTINGS.BASE_API}/files/upload-file`, formData);
  }

  /**
   * Download attachment from S3 URL
   * First tries blob download, falls back to direct link if CORS fails
   * @param url - S3 URL of the file
   * @param fileName - Name of the file to save
   */
  downloadAttachment(url: string, fileName: string): void {
    this.http.get(url, { responseType: 'blob' }).subscribe({
      next: (blob: Blob) => {
        this.downloadBlob(blob, fileName);
      },
      error: (error) => {
        console.warn('Blob download failed (likely CORS), using direct link:', error);
        // Fallback to direct download
        this.downloadDirect(url, fileName);
      }
    });
  }

  /**
   * Download blob using anchor element
   * @param blob - Blob to download
   * @param fileName - Name of the file to save
   */
  private downloadBlob(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.style.display = 'none';

    document.body.appendChild(anchor);
    anchor.click();

    // Clean up
    setTimeout(() => {
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(url);
    }, 100);
  }

  /**
   * Direct download using S3 URL (fallback for CORS issues)
   * @param url - S3 URL of the file
   * @param fileName - Name of the file to save
   */
  private downloadDirect(url: string, fileName: string): void {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.target = '_blank';
    anchor.style.display = 'none';

    document.body.appendChild(anchor);
    anchor.click();

    // Clean up
    setTimeout(() => {
      document.body.removeChild(anchor);
    }, 100);
  }
}
